import {Box, HBox} from '@buncha/components/core/view';
import {ChevronDownIcon, ChevronUpIcon, Divider} from 'native-base';
import {CustomText, H6Text} from '@buncha/components/core/text';
import React, {useCallback} from 'react';
import {useColorThemeType, useFontTheme} from '@buncha/appStyles/hooks/theme';

import {Accordian} from '@buncha/components/composites';
import {CustomFlatList} from '@buncha/components/core/list';
import FailedOrderItemList from '../FailedOrderItemList';
import {HomeScreens} from '@buncha/home/navigation/types';
import {Modules} from '@buncha/utils/types';
import {OrderItems} from '@buncha/batchDetails/types';
import {styles} from './styles';
import {useGetLocale} from '@buncha/localization/hooks';

interface FailedItemAccordionProps {
  defectedItem: OrderItems[];
  orderId: number;
}

const FailedItemAccordion: React.FC<FailedItemAccordionProps> = props => {
  const {defectedItem, orderId} = props;
  const theme = useColorThemeType();
  const muliFont = useFontTheme('muli');
  const {body} = useGetLocale(Modules.B2B, HomeScreens.B2B) ?? {};

  const renderItem = useCallback(
    ({item}: {item: OrderItems}) => {
      return <FailedOrderItemList item={item} orderId={orderId} />;
    },
    [orderId],
  );

  const divider = useCallback(
    () => (
      <Divider
        style={styles.dividerStyle}
        color={theme?.background.gray[200]}
      />
    ),
    [theme?.background.gray],
  );
  return (
    <Box>
      <Accordian
        isExpanded={true}
        header={
          <HBox style={styles.container}>
            <H6Text
              numberOfLines={2}
              style={[
                styles.dropText,
                {
                  fontFamily: muliFont[700].normal,
                  color: theme?.text.blue[300],
                },
              ]}>
              {body?.returnItems}
            </H6Text>
            <HBox style={styles.subContainer}>
              <Box
                style={[
                  styles.countBox,
                  {
                    backgroundColor: theme?.background.gray[200],
                  },
                ]}>
                <CustomText
                  style={[
                    {
                      fontFamily: muliFont[700].normal,
                      color: theme?.text.gray[100],
                    },
                  ]}>
                  {defectedItem?.length}
                </CustomText>
              </Box>
            </HBox>
          </HBox>
        }
        iconEnable={<ChevronUpIcon color={theme?.text.blue[300]} />}
        iconDisable={<ChevronDownIcon color={theme?.text.blue[300]} />}>
        <Box style={styles.listContainer}>
          <CustomFlatList
            data={defectedItem}
            renderItem={renderItem}
            ItemSeparatorComponent={divider}
          />
        </Box>
      </Accordian>
    </Box>
  );
};

export default React.memo(FailedItemAccordion);
